export default __webpack_public_path__ + "static/media/img_maintenance_wrench.1c042a1f.gif";